import React from 'react';
import { X } from 'lucide-react';

interface AboutProps {
  isOpen: boolean;
  onClose: () => void;
}

function About({ isOpen, onClose }: AboutProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white z-10">
          <h1 className="text-2xl font-bold">About Angel AI</h1>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="overflow-y-auto p-6">
          <div className="prose prose-blue max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Our Story</h2>
              <p className="text-lg leading-relaxed mb-4">
                Angel AI was created by Terrez Wells, a data scientist and AI specialist, in loving memory of his mother Angel. Her battle with illness inspired this project's core mission: advancing medical technology through AI to help others receive better care and support.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Our Mission</h2>
              <p className="text-lg leading-relaxed mb-4">
                We believe that access to quality healthcare and medical technology should be a fundamental right, not a privilege. Our goal is to revolutionize healthcare through AI technology by developing intelligent solutions that enhance patient care, support medical professionals, and improve health outcomes. This platform represents our commitment to breaking down barriers in healthcare and ensuring that advanced medical AI technology is accessible to all who need it.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">The Creator</h2>
              <p className="text-lg leading-relaxed mb-4">
                Terrez Wells is a data scientist specializing in artificial intelligence and machine learning applications in healthcare and medical technology. His expertise in developing AI solutions for medical care and patient support, combined with a deep personal connection to healthcare through his mother's experience, drives the development of innovative medical technologies. Inspired by his mother Angel's journey, Terrez focuses on creating AI tools that can enhance medical care and support for patients and healthcare providers alike. His vision is to transform healthcare through accessible, intelligent technology that puts patients first.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">Our Vision</h2>
              <p className="text-lg leading-relaxed">
                Angel AI represents more than just an AI assistant—it's a step toward a future where advanced technology enhances healthcare delivery and patient outcomes. We're committed to continuous innovation in medical AI technology while maintaining our core promise: developing intelligent solutions that improve healthcare accessibility and quality for everyone. Through our direct care tools and medical AI applications, we strive to create a healthcare system that is more efficient, compassionate, and accessible to all.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;